import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {ConnectionService} from './connection.service';
import {AppConfig} from '../app.config';
import {Task} from '../entities/Task';
import {Observable} from 'rxjs/Observable';
import {Responsible} from '../entities/SalesPerson';
import {AppTaskCategory} from '../entities/AppTaskCategory';
import {FilterModel} from '../entities/FilterModel';
import {RequestInterceptor} from "./Interceptors/RequestInterceptor";

@Injectable()
export class NotificationService {
  apiUrl: string;

  headers(company = null): Headers {
    return this.connectionService.GetAuthorizationHeader(company);
  }

  constructor(private http: Http, private requestInterceptor: RequestInterceptor, private connectionService: ConnectionService, private config: AppConfig) {
    this.apiUrl = config.getConfig('endPointApiUrl');
  }

  Post(object: any, company: string = null): Observable<any> {
    let url = this.apiUrl + 'api/MaintenanceNotification';

    return this.http.post(url, JSON.stringify(object), {headers: this.headers(company)});
  }

  Put(object: any, company: string = null): Observable<any> {
    let url = this.apiUrl + 'api/MaintenanceNotification';

    return this.http.put(url, JSON.stringify(object), {headers: this.headers(company)})
  }

  GetTaskCategories(company : string = null): Observable<AppTaskCategory[]> {
    let url = this.apiUrl + 'api/MaintenanceNotification/GetTaskCategories';
    let options = new RequestOptions({ headers: this.headers(company)});

    return this.requestInterceptor
      .get(url, options)
      .map(response => response.json() as AppTaskCategory[]);
  }

  GetAll(filterModel: FilterModel) {
    let url = this.apiUrl + 'api/MaintenanceNotification/?';

    url += 'fromDate=';
    if (filterModel.FromDate != null) {
      url += filterModel.FromDate;
    }
    url += '&toDate=';
    if (filterModel.ToDate != null) {
      url += filterModel.ToDate;
    }
    url += '&maintenanceObjectNo=';
    if (filterModel.maintenanceObjectNo != null) {
      url += filterModel.maintenanceObjectNo;
    }
    url += '&createdBy=';
    if (filterModel.createdBy != null) {
      url += filterModel.createdBy;
    }
    url += '&taskCreated=';
    if (filterModel.taskCreated != null) {
      url += filterModel.taskCreated;
    }
    url += '&categoryNo=';
    if (filterModel.categoryNo != null) {
      url += filterModel.categoryNo;
    }

    let options = new RequestOptions({ headers: this.headers() });

    return this.requestInterceptor
      .get(url, options)
      .map(response => response.json() as any[]);
  }

  Get(guid) {
    let url = this.apiUrl + 'api/MaintenanceNotification/' + guid;
    let options = new RequestOptions({ headers: this.headers() });

    return this.requestInterceptor
      .get(url, options)
      .map(response => response.json() as any);
  }


}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/notification.service.ts